<template>
  <div id="edit-category-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="width: 400px">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">EDIT CATEGORY</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <vue-spinner v-if="loading"></vue-spinner>
              <div v-else class="form-group" :class="{ 'has-error': errors.has('edit-category.title') }">
                <input class="form-control" type="text" autocomplete="off" placeholder="Title" name="title" v-model="title" v-validate="'required'">
                <span v-show="errors.has('edit-category.title')" class="help-block">{{ errors.first('edit-category.title') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :disabled="loading" class="btn green" @click.prevent="editCategory">Save changes</button>
          <button :disabled="loading" class="btn green" @click.prevent="removeCategory">Remove category</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {HTTP, ERROR} from "@/http-common";
  import Spinner from "@/components/Spinner";
  import {mapGetters} from "vuex";

  export default {
    name: 'RemoveFormModal',
    components: {
      VueSpinner : Spinner
    },
    props: ['id'],
    data() {
      return {
        loading: false,
        title: null,
      }
    },
    mounted() {
      $('#edit-category-modal').modal('show');

      this.loading = true;
      HTTP.get('tutorials/category/' + this.id).then(response => {
        ERROR(response);
        this.loading = false;
        this.title = response.data.data.category.title;
      }).catch(err => {
        this.loading = false;
        this.$notify({
          type: 'error',
          text: 'Something went wrong while trying to get category.'
        });
      });

      $('#edit-category-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },
    inject: {
      $validator: '$validator'
    },
    methods: {
      removeCategory() {
        this.loading = true;
        HTTP.post('/tutorials/remove-category', {
          id: this.id
        }).then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.loading = false;
            this.$emit('category-removed', this.id);
            this.$emit('display', false);
            $('#edit-category-modal').modal('hide');
          }
        })
          .catch(err => {
            this.$notify({
              type: 'error',
              text: 'Something went wrong while trying to remove category.'
            });
            $('#edit-category-modal').modal('hide');
            this.$emit('display', false);
          });
      },
      editCategory() {
        this.loading = true;
        HTTP.post('/tutorials/edit-category', {
          id: this.id,
          title: this.title
        }).then(response => {
            ERROR(response);
            if (response.status === 204) {
              this.loading = false;
              this.$emit('category-updated', this.id);
              this.$emit('display', false);
              $('#edit-category-modal').modal('hide');
            }
          })
          .catch(err => {
            this.$notify({
              type: 'error',
              text: 'Something went wrong while trying to edit category.'
            });
            $('#edit-category-modal').modal('hide');
            this.$emit('display', false);
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditCategoryModal.vue?20eccd99